import React, { Component } from "react";
import styled from "styled-components";

const Banner2 = require("../../../../assets/imgs/FD-7.65.jpg");

const ImagesWrapper = styled.div`
  width: 280px;
  height: 140px;
  cursor: pointer;
  margin-bottom: 15px;
`;

class OfferImages extends Component {
  state = {
    offersArr: [],
    itemsToShow: 0,
    expand: false,
  };

  componentDidMount() {
    let arr1 = [...this.props.cardData].map((data, index) => {
      return { ...data };
    });
    let count= arr1.length<=5?arr1.length:5;
    this.setState({ offersArr: arr1,itemsToShow:count });
  }
  handleView = () =>{
    let view =0;
    let catLength =this.state.offersArr.length;
    if(this.state.expand === true){
        view= catLength<=5?catLength:5;
    }else{
        view=catLength;
    }
    this.setState({expand:!this.state.expand,itemsToShow:view});
}
  render() {
    return (
      <div style={{ background: "#f7f7f7", position: "relative" }}>
        {this.state.offersArr.slice(0,this.state.itemsToShow).map((data, index) => {
          let listed_msg =`<ul>${data.offersText.map((data,index)=>{return `<li style="padding-bottom:10px">${data}</li>`})}</ul>`
          return (
            <ImagesWrapper key={index}>
              <img
                onClick={() => {
                  this.props.toggleGeneralOverlay(listed_msg.replace(/,/g,""));
                }}
                alt="image not found"
                // src={Banner2}
                src={data.offerImg}
                style={{width: "inherit",height:"inherit"}}
              />
            </ImagesWrapper>
          );
        })}
        {this.state.offersArr.length>5?<div className="action-elem disable-item" onClick={this.handleView}>{this.state.expand?"Show less":"Show more"}</div>:null}        
      </div>
    );
  }
}

export default OfferImages;
